import React, { useEffect, useState, useCallback } from "react";
import { Card, Form } from "@themesberg/react-bootstrap";
import CustomTable from "../../../components/CustomTable";
import BackButton from "../../../components/BackButton";
import useQuery from "../../../hooks/useQuery";
import { fetchApi } from "../../../redux/api";
import { useParams } from "react-router-dom";
import { FormLabel, InputGroup } from "react-bootstrap";
import moment from "moment-timezone";
import { formatNumber } from "../../../redux/utils";

export default function FundingReport({ match }) {
  const query = useQuery();
  const params = useParams();
  const accountTitle = params.account_title;
  // const account_number = params.account_code
  console.log("match...", match);
  const [searchTerm, setSearchTerm] = useState("");
  const funding_code = params.account_code;
  const [paymentScheduleTable, setPaymentScheduleTable] = useState([]);
  const [
    ,
    // tresuryDetails
    setTresuryDetails,
  ] = useState({});
const [form ,setForm] = useState({date_from: moment().subtract(1,'month').format("yyyy-MM-DD"), date_to: moment().format("yyyy-MM-DD")});
// alert(form.date_from)
  const fields = [
    // {
    //   title: 'S/N',
    //   custom: true,
    //   component: (item, idx) => <span>{idx + 1}</span>,
    // },
    {
      title: "Serial No",
      component: (i) => i.receipt_number,
      className: "text-center",
    },
    { title: "Fund Date", value: "fund_date", className: "text-center" },

    { title: "Account No", value: "Account_number", className: "text-center" },

    {
      title: "Dr",
      value: "dr",
      className: "text-right",
      custom: true,
      component: (item) => (
        <div style={{ textAlign: "right" }}>
          {parseFloat(item.dr).toLocaleString("en")}
        </div>
      ),
    },

    {
      title: "Cr",
      tableHeadStyle: { textAlign: "right", color: "black" },
      custom: true,
      component: (item) => (
        <div style={{ textAlign: "right" }}>
          {parseFloat(item.cr).toLocaleString("en")}
        </div>
      ),
    },
  ];
    const fields1 = [
      // {
      //   title: 'S/N',
      //   custom: true,
      //   component: (item, idx) => <span>{idx + 1}</span>,
      // },
      { title: "Date", value: "transaction_date", className: "text-center" },

      {
        title: "Account Name",
        value: "account_name",
        className: "text-center",
      },
      {
        title: "Account No",
        value: "account",
        className: "text-center",
      },
      {
        title: "Description",
        value: "transcation_description",
        className: "text-left",
      },
      {
        title: "Reference No",
        component: (i) => i.invoice_number,
        className: "text-center",
      },
      {
        title: "Dr",
        value: "dr",
        className: "text-right",
        custom: true,
        component: (item) => (
          <div style={{ textAlign: "right" }}>
            {parseFloat(item.dr).toLocaleString("en")}
          </div>
        ),
      },

      {
        title: "Cr",
        tableHeadStyle: { textAlign: "right", color: "black" },
        custom: true,
        component: (item) => (
          <div style={{ textAlign: "right" }}>
            {parseFloat(item.cr).toLocaleString("en")}
          </div>
        ),
      },
      // {
      //   title: "Balance",
      //   custom: true,
      //   component: (item) => (
      //     <div style={{ textAlign: "right" }}>
      //       {parseFloat(item.dr - item.cr).toLocaleString("en")}
      //     </div>
      //   ),
      // },
    ];

  const getAccountHistory = useCallback(() => {
    fetchApi(`tsa-account?query_type=history&account=${funding_code}`)
      .then((data) => {
        if (data.results) {
          setPaymentScheduleTable(data.results);
          setTresuryDetails(data.results[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [funding_code]);
  const handleChange = () => {
    
    setForm()
  }

  useEffect(() => {
    getAccountHistory();
    // fetch(`${api}/post_tsa_funding_s`, {
    //   method: "POST",
    //   headers: {
    //     "Content-type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     query_type : 'select_by_mda_account_number',
    //     account_number : account_number

    //   }),
    // }).then(function (response) {
    //   return response.json();
    // })
    //   .then((data) => {
    //     console.log("data", data)
    //    if(data.result){
    //     setPaymentScheduleTable(data.result);
    //     setTresuryDetails(data.result[0])

    //    }
    //   })

    //   .catch((err) => {
    //     // alert(err);
    //     // setLoadSpinner(false);
    //   });
  }, [getAccountHistory]);

  let rows = [];

  paymentScheduleTable &&
    paymentScheduleTable.forEach((item) => {
      if (
        item.funding_code &&
        item.funding_code.toLowerCase().indexOf(searchTerm) === -1 &&
        item.total_amount.indexOf(searchTerm) === -1 &&
        item.total_amount.toLowerCase().indexOf(searchTerm) === -1
      ) {
        return;
      }

      rows.push(item);
    });

  return (
    <>
      <BackButton />
      {/* <Button
          onClick={() => history(-2)}
          style={{ backgroundColor: 'rgb(25, 135, 84)', color: 'white' }}
        >
          Back
        </Button> */}
        {/* {JSON.stringify(rows)} */}
      <Card>
        <Card.Header>{accountTitle}</Card.Header>

        <Card.Body>
          <div className="d-flex justify-content-between font-weight-bold">
            <p>
              Total Credit : {formatNumber(rows.reduce((it, id) => it + parseInt(id.cr), 0))}
            </p>
            <p>
              Total Debit : {formatNumber(rows.reduce((it, id) => it + parseInt(id.dr), 0))}
            </p>
            <p>Total Balance : {formatNumber(rows.reduce((it, id) => it + parseInt(id.dr - id.cr), 0)) }</p>
          </div>
          <div>
            <form className="d-flex justify-content-between">
              <div>
                <FormLabel>Date From</FormLabel>
                <Form.Control
                  type="date"
                  value={form.date_from}
                  onChange={handleChange}
                />
              </div>
              <div>
                <FormLabel>Date To</FormLabel>
                <Form.Control
                  type="date"
                  value={form.date_to}
                  onChange={handleChange}
                />
              </div>
            </form>
          </div>
          <form>
            <Form.Control
              placeholder="Search"
              style={{ padding: "4px", margin: "5px", width: "100%" }}
            />
          </form>
<div className="table-responsive">

          <CustomTable
            headBackground="white"
            headColor="black"
            size="sm"
            className="file-list"
            fields={fields1}
            data={rows}
          />
</div>
        </Card.Body>
      </Card>
    </>
  );
}
